import React from "react";
import "./HouseingTransform.css";

const ManpowerTransform = () => {
  return (
    <section className="workplace-cta-section">
      <div className="workplace-cta-container">
        <h2 className="workplace-cta-title">
          Get the Right Manpower for Your Facility
        </h2>

        <p className="workplace-cta-text">
          Access verified, trained, and compliant manpower solutions tailored to
          your operational needs
        </p>

        <a
          href="https://wa.me/919899811123?text=Manpower%20Outsourcing"
          target="_blank"
          rel="noopener noreferrer"
          className="workplace-cta-btn"
        >
          Request Manpower Outsourcing →
        </a>
      </div>
    </section>
  );
};

export default ManpowerTransform;
